<template lang="pug">

ListResend
</template>

  
  <script>
import ListResend from "../components/ListResend.vue";
export default {
  name: "ContactUs",
  components: {
    ListResend,
  },
  data: () => ({
    title: "List Resend",
  }),
};
</script>
  
  <style>
.v-main__wrap {
  background: #f3f3f4;
}

.v-application .blue {
  background-color: #01c8f1 !important;
  border-color: #01c8f1 !important;
}
</style>
  